import { createAsyncThunk } from '@reduxjs/toolkit';
import cantineAPI from '../../services/cantineAPI';
import { 
  setCantines, 
  setProductionTypes,
  apiRequestStart, 
  apiRequestSuccess, 
  apiRequestFailure,
  duplicateCantine,
  updateCantine,
  removeCantine,
  addCantineId,
  addCantine
} from './cantineSlice';
import { toast } from "react-toastify";

// Fetch all Cantines
export const fetchCantines = createAsyncThunk(
  'cantine/fetchCantines',
  async (params, { dispatch }) => {
    try {
      dispatch(apiRequestStart());
      const response = await cantineAPI.getAllCantines(params);
      // localStorage.removeItem("cantine_id");
      dispatch(setCantines(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
      throw error;
    }
  }
);

// Fetch cantines by Id
export const fetchCantinesById = createAsyncThunk(
  `cantine/fetchCantines`,
  async (params, { dispatch }) => {
    try {
      dispatch(apiRequestStart());
      const response = await cantineAPI.getCantine(params);
      localStorage.setItem('cantine_id',params)
      // console.log(response.data,"data123")
      dispatch(addCantineId(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
      throw error;
    }
  }
);

// Fetch Production Types
export const fetchProductionTypes = createAsyncThunk(
  'cantine/fetchProductionTypes',
  async (_, { dispatch }) => {
    try {
      dispatch(apiRequestStart());
      const response = await cantineAPI.getProductionTypes();
      dispatch(setProductionTypes(response.data.data));
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
      throw error;
    }
  }
);

// Create a new Cantine
export const createCantine = createAsyncThunk(
  'cantine/createCantine',
  async (cantineData, { dispatch }) => {
    try {
      dispatch(apiRequestStart());
      const response = await cantineAPI.createCantine(cantineData);
      dispatch(addCantine(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
      throw error;
    }
  }
);

// Duplicate a cantine
export const duplicateCantineAsync = (cantineId) => async (dispatch) => {
  try {
    dispatch(apiRequestStart()); // Start loading

    const response = await cantineAPI.duplicateCantine(cantineId);
    if (response.data.success) {
      dispatch(duplicateCantine(response.data.data));
      dispatch(apiRequestSuccess());
    } else {
      dispatch(apiRequestFailure("Failed to duplicate cantine"));
    }
  } catch (error) {
    dispatch(apiRequestFailure(error.response?.data?.message || "Error duplicating cantine"));
  }
};

// Delete cantina
export const deleteCantine = (cantineId) => async (dispatch) => {
  try {
    dispatch(apiRequestStart());
    const response = await cantineAPI.deleteCantine(cantineId);
    dispatch(removeCantine(cantineId));
    toast.success(response?.data?.message)
    dispatch(apiRequestSuccess());
  } catch (error) {
    dispatch(apiRequestFailure(error.response?.data || "Error deleting cantine"));
  }
};

// Update cantine
export const updateCantineAsync = createAsyncThunk(
  'cantine/updateCantine',
  async ({ cantineId, cantineData }, { dispatch }) => {
    try {
      dispatch(apiRequestStart());
      const response = await cantineAPI.updateCantine(cantineId, cantineData);
      dispatch(updateCantine(response.data.data));
      toast.success(response?.data?.message)
      dispatch(apiRequestSuccess());
      return response.data.data;
    } catch (error) {
      dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
      throw error;
    }
  }
);

// Certify cantine
// export const certifyCantina = createAsyncThunk(
//   'cantine/certifyCantina',
//   async ({ dataForCertification }, { dispatch }) => {
//     try {
//       dispatch(apiRequestStart());
//       const response = await cantineAPI.certifyCantine(dataForCertification);
//       // dispatch(certifyCantine(response.data.data));
//       toast.success(response?.data?.message);
//       dispatch(apiRequestSuccess());
//       return response.data.data;
//     } catch (error) {
//       dispatch(apiRequestFailure(error.response?.data || 'An error occurred'));
//       throw error;
//     }
//   }
// );
